import { createContext } from 'react';
export const PublishedDossierContext = createContext({
    placeholderContextValue: true,
});
PublishedDossierContext.displayName = 'PublishedDossierContext';
//# sourceMappingURL=PublishedDossierContext.js.map